import { soloBankABI } from '@/utils/abi';
import BigNumber from 'bignumber.js';
import { EventBus } from '@/utils/EventBus';
import { metaMaskErrorHandler, MetaError } from '@/utils/errorHandler';

let contract: any = null;
const contractAddress = process.env.VUE_APP_SOLO_BANK_CONTRACT_ADDRESS;

export const initContract = () => {
  if (window.web3 && contract === null) {
    contract = new window.web3.eth.Contract(soloBankABI, contractAddress);
  }
};

export const poolDepositInfo = async (pid: number) => {
  initContract();
  try {
    const res = await contract.methods.poolDepositInfo(pid).call();
    return res;
  } catch (e) {
    // @ts-ignore
    console.log(pid, e);
    return null;
  }
};

export const userDepositInfo = async (pid: number, account: string) => {
  initContract();
  try {
    const res = await contract.methods.userDepositInfo(pid, account).call();
    return res;
  } catch (e) {
    // @ts-ignore
    console.log(pid, e);
    return null;
  }
};

export const totalValue = async () => {
  initContract();
  try {
    const res = await contract.methods.totalValue().call();
    return {
      totalDepositValue: window.web3.utils.fromWei(
        res.totalDepositValue,
        'ether'
      ),
      totalRewardsValue: window.web3.utils.fromWei(
        res.totalRewardsValue,
        'ether'
      ),
    };
  } catch (e) {
    // @ts-ignore
    console.log(e);
    return null;
  }
};

export const getTotalDeposit = async (pid: number) => {
  initContract();
  try {
    const amount = await contract.methods.getTotalDeposit(pid).call();
    return window.web3.utils.fromWei(amount, 'ether');
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const availableDepositAmount = async (pid: number, account: string) => {
  initContract();
  try {
    const amount = await contract.methods
      .availableDepositAmount(pid, account)
      .call();
    return window.web3.utils.fromWei(amount, 'ether');
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const poolInfo = async (pid: number) => {
  initContract();
  try {
    const res = await contract.methods.poolInfo(pid).call();
    return {
      allocPoint: window.web3.utils.fromWei(res.allocPoint, 'ether'),
    };
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const totalAllocPoint = async () => {
  initContract();
  try {
    const amount = await contract.methods.totalAllocPoint().call();
    return window.web3.utils.fromWei(amount, 'ether');
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const userInfo = async (pid: number, account: string) => {
  initContract();
  try {
    const res = await contract.methods.userInfo(pid, account).call();
    return {
      amount: window.web3.utils.fromWei(res.amount, 'ether'),
    };
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const userPendingReward = async (pid: number, account: string) => {
  initContract();
  try {
    const amount = await contract.methods
      .userPendingReward(pid, account)
      .call();
    return window.web3.utils.fromWei(amount, 'ether');
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const deposit = async (
  pid: number,
  amount: BigNumber,
  account: string
) => {
  initContract();
  if (!account) {
    return;
  }
  try {
    contract.methods
      .deposit(
        pid,
        window.web3.utils.toWei(
          `${pid === 2 ? `0` : amount.toString()}`,
          'ether'
        )
      )
      .send({
        value:
          pid === 2 ? window.web3.utils.toWei(amount.toString(), 'ether') : `0`,
        from: account,
      })
      .once('sending', () => {
        EventBus.$emit('trx-result', { status: 'loading', trxId: '' });
      })
      .once('transactionHash', (hash: string) => {
        EventBus.$emit('item-transfer', null, 'alpaca');
        EventBus.$emit('trx-result', { status: 'completed', trxId: hash });
      })
      .on('error', (err: MetaError) => {
        metaMaskErrorHandler(err);
      });
  } catch (err) {
    console.log(err);
  }
};

export const claim = async (pid: number, account: string) => {
  await deposit(pid, new BigNumber(0), account);
};

export const withdraw = async (
  pid: number,
  amount: BigNumber,
  account: string
) => {
  initContract();
  if (!account) {
    return;
  }
  try {
    contract.methods
      .withdraw(pid, window.web3.utils.toWei(`${amount}`, 'ether'))
      .send({
        from: account,
      })
      .once('sending', () => {
        EventBus.$emit('trx-result', { status: 'loading', trxId: '' });
      })
      .once('transactionHash', (hash: string) => {
        EventBus.$emit('item-transfer', null, 'alpaca');
        EventBus.$emit('trx-result', { status: 'completed', trxId: hash });
      })
      .on('error', (err: MetaError) => {
        metaMaskErrorHandler(err);
      });
  } catch (err) {
    console.log(err);
  }
};
